<template>
  <div class="detail">
    <div class="title flex flex-y-center container">
      <span @click="indexHandle()"><img src="../../assets/images/home.png" alt="">首页</span>
      <span v-for="(item,index) in this.pathList" :key="index" @click="navHandle(item)"><i>></i>{{ item.strName }}</span>
    </div>
    <div class="container">
      <h2 v-html="detailInfo.strMasTitle"></h2>
      <h3 class="flex flex-x-center flex-y-center">
        <span>{{ detailInfo.strPubDate }}</span>
        <span>来源：{{ detailInfo.strSource }}</span>
        <span>点击：{{ detailInfo.intCount }}</span>
      </h3>
      <div class="content-wrap" v-html="detailInfo.strContent"></div>
    </div>
  </div>
</template>

<script>
import { detailData } from '@/api/configuration'
import { get } from '../../utils/helpers'
export default {
  name: 'Detail',
  props: {},
  data () {
    return {
      pathList: [], //面包屑导航
      detailInfo: {}, //详情
    }
  },
  created () {
    this.getDetailData()
  },
  methods: {
    //获取详情数据
    getDetailData () {
      var param = {
        strId: this.$route.query.strId,
        strWebSiteId: this.$route.query.strWebSiteId,
      };
      detailData(param)
        .then(res => {
          // 处理面包屑导航
          let colPathList = get(['data', 'objList', 'colPathList'], res.data);
          for (const key in colPathList) {
            this.pathList.push(colPathList[key])
          }
          this.pathList.splice(0, 1)
          // 获取内容详情
          this.detailInfo = get(['data', 'objList', 'info'], res.data)
          //document.title = get(['data', 'objList', 'info', 'strMasTitle'], res.data)
          document.title = res.data.data.objList.info.strMasTitle.replace(/<[^>]+>/g, '')
        })
        .catch(err => {
          this.$message.destroy()
          this.$message.error(err)
        })
    },
    // 首页跳转
    indexHandle () {
      this.$router.push({ path: '/index', query: { strWebSiteId: this.$route.query.strWebSiteId } })
    },
    // 菜单跳转
    navHandle (item) {
      this.$router.push({ path: '/list', query: { strId: item.strId, strWebSiteId: this.$route.query.strWebSiteId } })
    }
  }
}
</script>

<style scoped lang="scss">
.detail {
  .container {
    width: 1280px;
    margin: 0 auto;
  }
  .title {
    line-height: 50px;
    position: relative;
    border-bottom: 1px solid #eaeaea;
    span {
      margin: 0;
      padding: 0;
      color: #393838;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      align-items: center;
      &:hover {
        color: #d70000;
      }
      img {
        margin: 0 6px 0 0;
      }
      i {
        font-style: normal;
        margin: 0 6px;
      }
    }
  }
  h2 {
    color: #000799;
    font-weight: bold;
    text-align: center;
    font-size: 32px;
    line-height: 56px;
    padding: 25px 0 5px;
    margin: 0;
  }
  h3 {
    font-weight: normal;
    font-size: 14px;
    padding: 30px 0 15px;
    color: #000;
    margin: 0;
    span {
      margin: 0 5px;
    }
  }
  .content-wrap {
    border-top: 1px solid #e5e5e5;
    box-sizing: border-box;
    padding: 0 30px;
  }
}
</style>